module.exports = __webpack_public_path__ + "static/media/b1.39f24438.png";